<template>
  <section class="app-main">
    <transition
      name="fade-transform"
      mode="out-in"
    >
      <!--      <keep-alive :include="cachedViews">-->
      <div>
        <!--        <keep-alive include="MyCustomer,PublicCustomer">-->
        <keep-alive :include="cachedViews">
          <!--        <keep-alive>-->
          <router-view :key="key" />
        </keep-alive>
        <!--        <router-view-->
        <!--          v-if="$route.meta.noCache"-->
        <!--          :key="key"-->
        <!--        />-->
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  data() {
    return {
      noCacheViews: [],
    };
  },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    },
  },
  mounted() {
    // setTimeout(()=>{
    //   this.showOrder()
    // },10000)
  },
  methods: {
    showOrder() {
      let msg = "<div>";
      for (let i = 0; i < 5; i++) {
        msg = `${msg}<div class="notifyItem"><p><span>张小芳</span>“委托招聘”开单，金额为“4662.00”元</p><div><i class="iconfont icon-hua" style="color:#EC1F1F">10</i><i class="iconfont icon-dianzan" style="color:#6BA3E1">2</i><i class="iconfont icon-guzhang" style="color:#17527E">2</i></div></div>`;
      }
      msg = `${msg}</div>`;
      this.$notify({
        title: "今日开单提醒",
        dangerouslyUseHTMLString: true,
        message: msg,
        duration: 0,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  height: calc(100vh - 84px);
  width: 100%;
  position: relative;
  overflow: scroll;
  box-sizing: border-box;
  padding: 12px 2px 0 12px;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
.el-notification {
  width: 650px;
  .el-notification__group {
    width: 100%;
  }
}
.notifyItem {
  display: flex;
  justify-content: space-around;
  p {
    width: 400px;
    margin: 0;
    height: 38px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 38px;
    color: #333333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    span {
      color: #027aff;
    }
  }
  & > div {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    height: 38px;
    align-items: center;
    font-size: 18px;
    i {
      font-size: 20px;
      margin: 0 5px;
      cursor: pointer;
    }
  }
}
</style>
